import { useEffect, useRef } from 'react'

import { usePopoverTour } from './PopoverTourContext.js'
import { useAdminModeOnboarding } from './useAdminModeOnboarding.js'

/**
 * Automatically starts the popover tour when an admin visits admin mode for the first time.
 */
export const AdminModeOnboardingTrigger = () => {
  const { hasCompletedTour, getStepProgress } = useAdminModeOnboarding()
  const { startTour } = usePopoverTour()
  const hasStarted = useRef(false)

  useEffect(() => {
    if (!hasCompletedTour && !hasStarted.current) {
      hasStarted.current = true
      startTour(getStepProgress(), true)
    }
  }, [hasCompletedTour, startTour, getStepProgress])

  return null
}
